export const formatPrice = (value, currency) => {
    if (!currency) {
        return value;
    }
    if (currency.align === 1) {
        return `${currency.symbol}${value}`;
    } else {
        return `${value}${currency.symbol}`;
    }
}
